<template>
  <slot name="activity">
    <span class="pull-right text-muted"> {{ post.like_count }} likes - {{ post.comments.length }} comments</span>
  </slot>
</template>
<script>
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
}
</script>